// extracted by mini-css-extract-plugin
export default {"arrowWrapper":"views-ProductPage-themes-PP-addToCart__arrowWrapper--Xj_OJ"};